import registerComponent from './register-component';
import registeredComponents from './registered-components';

export default {
  registerComponent,
  registeredComponents,
};
